import { activePortalSettings } from '../config/portal-regions';
type GtagFn = (...args: unknown[]) => void;
const GA_MEASUREMENT_ID = activePortalSettings.gaMeasurementId;
declare global {
    interface Window { dataLayer: unknown[]; gtag?: GtagFn; }
}
let gaLoaded = false;
let analyticsAllowed = false;
const storageConsent = (granted: boolean) => ({ ad_user_data: 'denied', ad_personalization: 'denied', ad_storage: 'denied', analytics_storage: granted ? 'granted' : 'denied' });
export const loadGoogleAnalytics = () => {
    if (typeof window === 'undefined' || !GA_MEASUREMENT_ID) return;
    analyticsAllowed = true;
    (window as unknown as Record<string, unknown>)[`ga-disable-${GA_MEASUREMENT_ID}`] = false;
    if (gaLoaded) return;
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || ((...args: unknown[]) => { window.dataLayer.push(args); });
    window.gtag('consent', 'default', storageConsent(false));
    window.gtag('consent', 'update', storageConsent(true));
    if (document.querySelector('script[data-ga-loader="true"]')) return;
    const script = document.createElement('script');
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
    script.async = true;
    script.setAttribute('data-ga-loader', 'true');
    script.onload = () => {
        if (!analyticsAllowed || !window.gtag) return;
        window.gtag('js', new Date());
        window.gtag('config', GA_MEASUREMENT_ID, { anonymize_ip: true, send_page_view: true });
        gaLoaded = true;
    };
    document.head.appendChild(script);
};
export const clearGoogleAnalytics = () => {
    const wasLoaded = analyticsAllowed || gaLoaded;
    analyticsAllowed = false;
    gaLoaded = false;
    if (typeof window === 'undefined') return false;
    if (GA_MEASUREMENT_ID) (window as unknown as Record<string, unknown>)[`ga-disable-${GA_MEASUREMENT_ID}`] = true;
    const script = document.querySelector<HTMLScriptElement>('script[data-ga-loader="true"]');
    if (script) { script.onload = null; script.remove(); }
    // Do not load or invoke Google merely to record a rejection.
    for (const cookie of document.cookie.split(';')) {
        const name = cookie.trim().split('=')[0];
        if (!/^(_ga(?:_|$)|_gid$|_gat)/.test(name)) continue;
        const domains = ['', window.location.hostname, ...['.simplysend.email', '.simplysend.dev', '.simplysend.ai'].filter(domain => window.location.hostname.endsWith(domain))];
        for (const domain of domains) document.cookie = `${name}=; Max-Age=0; Path=/${domain ? `; Domain=${domain}` : ''}`;
    }
    return wasLoaded;
};
